<ng-container *ngIf="label">
    <a *ngIf="href$ | async as href"
       [routerLink]="href.path"
       [queryParams]="href.queryParams"
       class="label-span">{{label!.name}}</a>
</ng-container>
